export default "<ckeditor [editor]=\"Editor\" data=\"<p>Hello, world!</p>\">\r\n</ckeditor>";